import { Stack, SxProps, Typography } from "@mui/material";

const TwoLineTextDisplay = ({
  line1Text,
  line2Text,
  styleOverrides
}: {
  line1Text: string;
  line2Text: string;
  styleOverrides?: SxProps;
}) => (
  <Stack direction="column">
    {[line1Text, line2Text].map((eachData) => (
      <Typography
        sx={{ fontSize: "14px", color: "grey.900", ...styleOverrides }}
        key={eachData}
      >
        {eachData}
      </Typography>
    ))}
  </Stack>
);

export default TwoLineTextDisplay;
